import { filter, map, pluck } from 'rxjs/operators'
import { StateObservable, ofType, ActionsObservable, combineEpics } from 'redux-observable'
import { mediaType as MediaType } from '@bt-react/constants'
import { State, ReduxAction } from '../../../reducers/reducerType'
import trackActions from '../../../actions/tracks'
import { TrackType } from '../../../actions/tracks/trackTypes'
import isEmpty from 'lodash/isEmpty'
import selectIsLocalParticipantDialedIn from '../../../selectors/selectIsLocalParticipantDialedIn'

export const selectAudioDevice$ = (actions$: ActionsObservable<ReduxAction>, state$: StateObservable<State>) => actions$.pipe(
  ofType(TrackType.SET_SELECTED_AUDIO_DEVICE),
  pluck<ReduxAction, string>('payload'),
  filter<string>((deviceId) =>
    (state$.value.room.mediaType !== MediaType.NONE || state$.value.layouts.mediaLayout.mediaSidebarActive) &&
    state$.value.room.room !== null && !!state$.value.user.BTID && !!state$.value.syncSeatingOrder.seatingOrder[state$.value.user.BTID] &&
    !isEmpty(deviceId) &&
    !selectIsLocalParticipantDialedIn(state$.value)
  ),
  map(deviceID => trackActions.createLocalAudioTrack(deviceID))
)

export const selectVideoDevice$ = (actions$: ActionsObservable<ReduxAction>, state$: StateObservable<State>) => actions$.pipe(
  ofType(TrackType.SET_SELECTED_VIDEO_DEVICE),
  pluck<ReduxAction, any>('payload'),
  filter((payload) =>
    (state$.value.room.mediaType !== MediaType.NONE || state$.value.layouts.mediaLayout.mediaSidebarActive) &&
    state$.value.room.room !== null && !!state$.value.user.BTID && !!state$.value.syncSeatingOrder.seatingOrder[state$.value.user.BTID] &&
    !isEmpty(payload.selectedDevice)
  ),
  map(payload => trackActions.createLocalVideoTrack(payload.selectedDevice, payload.background))
)

export default combineEpics(selectAudioDevice$, selectVideoDevice$)
